module.exports = __webpack_public_path__ + "assets/wikijs.f9e31569.svg";